(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Dynamic-Blog-Section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const POSTS_PER_PAGE = 3;
    // TAB SWITCHING
    document.querySelectorAll('.journal-tab .left-box .box').forEach((box) => {
      box.addEventListener('click', function () {
        const tabId = this.dataset.tab;
        document.querySelectorAll('.journal-tab .left-box .box').forEach((b) => b.classList.remove('active'));
        document.querySelectorAll('.blog-box').forEach((b) => b.classList.remove('active'));
        this.classList.add('active');
        document.querySelector(`.blog-box[data-tab='${tabId}']`).classList.add('active');
      });
    });
    // SEARCH FUNCTION
    const searchInput = document.getElementById('tab-search');
    searchInput.addEventListener('input', function () {
      const searchValue = this.value.toLowerCase();
      const activeBox = document.querySelector('.blog-box.active');
      const posts = activeBox.querySelectorAll('.post-item');
      posts.forEach((post) => {
        const title = post.querySelector('.title').textContent.toLowerCase();
        post.style.display = title.includes(searchValue) ? 'flex' : 'none';
      });
    });
    // PAGINATION PER TAB
    document.querySelectorAll('.blog-box').forEach((tabBox) => {
      const posts = Array.from(tabBox.querySelectorAll('.post-item'));
      const pagination = tabBox.querySelector('.journal-pagination');
      const numberBox = pagination.querySelector('.number-box');
      const prevBtn = pagination.querySelector('.prev');
      const nextBtn = pagination.querySelector('.next');
      const totalPages = Math.ceil(posts.length / POSTS_PER_PAGE);
      let currentPage = 1;
      function updateButtons() {
        if (prevBtn) prevBtn.classList.toggle('disabled', currentPage <= 1);
        if (nextBtn) nextBtn.classList.toggle('disabled', currentPage >= totalPages);
      }
      function showPage(page) {
        currentPage = page;
        posts.forEach((post, index) => {
          post.style.display = index >= (page - 1) * POSTS_PER_PAGE && index < page * POSTS_PER_PAGE ? 'flex' : 'none';
        });
        numberBox.innerHTML = '';
        for (let i = 1; i <= totalPages; i++) {
          const num = document.createElement('div');
          num.classList.add('number');
          if (i === currentPage) num.classList.add('active');
          num.innerHTML = `
<p class="text_600 font_secondary color_primary_tint1 text_md">${i}</p>
`;
          num.addEventListener('click', () => showPage(i));
          numberBox.appendChild(num);
        }
        updateButtons();
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (currentPage > 1) showPage(currentPage - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (currentPage < totalPages) showPage(currentPage + 1);
        });
      }
      // SHOW pagination if more than 2 posts
      if (posts.length <= 2) {
        pagination.style.display = 'none';
      } else {
        pagination.style.display = 'block';
        showPage(1);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Journal-Tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.journal-tab .left-box .box').forEach(box => {
  box.addEventListener('click', function() {
    const tabId = this.getAttribute('data-tab');
    
    // remove active class from all boxes and panels
    document.querySelectorAll('.journal-tab .left-box .box').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.journal-tab .tab-content .tab-panel').forEach(p => p.classList.remove('active'));
    
    // add active class to clicked box and panel
    this.classList.add('active');
    document.querySelector(`.journal-tab .tab-content .tab-panel[data-content="${tabId}"]`).classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
